import type { HttpClient } from "../client/types";
import type { AgeClassification } from "../client/types/age-classification.types";
import { getApi } from "../client/apiClient";

const createAgeClassificationEndpoints = (client: HttpClient = getApi()) => ({
  getAgeClassifications: async (): Promise<AgeClassification[]> => {
    const { data } = await client.get<AgeClassification[]>(
      "/age-classifications"
    );
    return data;
  },
  getAgeClassificationById: async (id: number): Promise<AgeClassification> => {
    const { data } = await client.get<AgeClassification>(
      `/age-classifications/${id}`
    );
    return data;
  },
});

export type AgeClassificationEndpoints = ReturnType<
  typeof createAgeClassificationEndpoints
>;

export const ageClassificationEndpoints = createAgeClassificationEndpoints();
